import { Autocomplete, Button, TextField, Switch } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setBranchPosConfigurations } from './BranchSettingsSlice'
import { successSnackMsg } from '../../../../Custom Hooks/SnackkBarUtilities'
import { listAggregatorsAPI } from '../Aggregator/aggregatorAPI'
// WhatsApp moved to centralized Notification Settings (Staff → HRM → Notifications → Settings → WhatsApp tab)

const PosBranchConfigurations = ({ onWhatsAppConfig,onWhatsAppEnableChange }) => {

    const dispatch = useDispatch()
    const decimalPosition = localStorage.getItem("decimalPosition")
    const branchSettingsView = useSelector((state) => state.branchSettingsSliceNew.rowData);
    const CategoryList = useSelector((state) => state.categorySlice.value);
    const userInfo = useSelector((state) => state.loginResponseSlice.value);
    const branchId = userInfo?.branchPk;
    //Active Employee List
    const employeeList = useSelector((state) => state.allActiveEmployeeSlice.value);
    const aggregatorList = useSelector((state) => state.aggregatorSlice.aggregatorList);

    const [formValues, setFormValues] = useState({
        enableKot: false,
        enablePosDevices: false,
        posDevices: [],
        recipeAuto: false,
        updateOrdAuth: false,
        updateOrdAuthEmployees: [],
        cancelOrdAuth: false,
        cancelOrdAuthEmployees: [],
        addDiscountAuth: false,
        addDiscountAuthEmployees: [],
        enableMultipleOrder: false,
        deliveryCharge: false,
        deliveryAmt: "",
        deliveryChargeMode: "flat",
        perKmCharge: "",
        freeDeliveryAbove: "",
        kmRangeRules: [],
        deliveryChargeAggregators: [],
        packageCharge: false,
        openingBalFromInvenrory: false,
        iaPhysicalClosingManual: false,
        packageAmt: "",
        printCount: null,
        noDecreasePrice: false,
    })
    const [validationAlert, setValidationAlert] = useState({})
    // WhatsApp states removed - now in centralized Notification Settings


    const getFormInfo = (key) => (e, newValue) => {
        if (key === 'deliveryChargeAggregators') {
            console.log('🎯 Aggregators selected:', newValue);
        }
        setFormValues({ ...formValues, [key]: newValue !== undefined ? newValue : e.target.value })
    }
    const checkboxChange = (key) => (e) => {
        setFormValues({ ...formValues, [key]: e.target.checked });
        if (key === "enablePosDevices" && e.target.checked === false) {
            setFormValues((prev) => ({ ...prev, posDevices: [] }));
        }
    };
    
    const roundValues = () => {
        setFormValues({
            ...formValues,
            deliveryAmt: Number(formValues.deliveryAmt)?.toFixed(decimalPosition),
            packageAmt: Number(formValues.packageAmt)?.toFixed(decimalPosition),
            perKmCharge: formValues.perKmCharge !== "" ? Number(formValues.perKmCharge)?.toFixed(decimalPosition) : "",
            freeDeliveryAbove: formValues.freeDeliveryAbove !== "" ? Number(formValues.freeDeliveryAbove)?.toFixed(decimalPosition) : ""
        })
    }


    useEffect(() => {
        dispatch(setBranchPosConfigurations(formValues))
    }, [formValues])

    useEffect(() => {
        // Load aggregator list when component mounts
        listAggregatorsAPI({ branchId });
    }, [])

    useEffect(() => {
        if (branchSettingsView) {
            console.log('🔍 Restoring branch settings, deliveryChargeAggregatorId:', branchSettingsView?.deliveryChargeAggregatorId);
            console.log('🔐 Employee Auth from backend:', {
                updateOrdAuth: branchSettingsView?.updateOrdAuth,
                updateOrdAuthEmployees: branchSettingsView?.updateOrdAuthEmployees,
                cancelOrdAuth: branchSettingsView?.cancelOrdAuth,
                cancelOrdAuthEmployees: branchSettingsView?.cancelOrdAuthEmployees,
                addDiscountAuth: branchSettingsView?.addDiscountAuth,
                addDiscountAuthEmployees: branchSettingsView?.addDiscountAuthEmployees
            });
            const restoredAggregators = branchSettingsView?.deliveryChargeAggregatorId?.map((agg) => ({ _id: agg?.aggregatorId, name: agg?.aggregatorName })) || [];
            console.log('🔍 Restored aggregators:', restoredAggregators);
            setFormValues({
                ...formValues,
                enableKot: branchSettingsView?.enableKot,
                enablePosDevices: Array.isArray(branchSettingsView?.posDevices)
                    ? branchSettingsView.posDevices.length > 0
                    : !!branchSettingsView?.isCafeteria,
                posDevices: Array.isArray(branchSettingsView?.posDevices)
                    ? branchSettingsView.posDevices.map((device, index) => ({
                        _id: device?._id || index,
                        name: device?.name || device?.deviceName || `POS Device ${index + 1}`,
                        employees: (device?.employees || device?.assignedEmployees || []).map((emp) => ({
                            _id: emp?.employeeId || emp?._id,
                            staff_name: emp?.name || emp?.staff_name,
                        })),
                        categories: (device?.categories || []).map((cat) => ({
                            _id: cat?.categoryId || cat?._id,
                            categoryName: cat?.categoryName,
                        })),
                        allowSpecialItems: device?.allowSpecialItems ?? device?.specialPosCategory ?? false,
                        allowExternalOrders: device?.allowExternalOrders ?? device?.acceptExternalOrders ?? false,
                    }))
                    : (branchSettingsView?.cafeEmpId || branchSettingsView?.cafeCatId
                        ? [{
                            _id: "legacy-pos-device",
                            name: "POS Device",
                            employees: (branchSettingsView?.cafeEmpId || []).map((emp) => ({
                            _id: emp?.empId,
                            staff_name: emp?.staff_name,
                        })),
                        categories: (branchSettingsView?.cafeCatId || []).map((cat) => ({
                            _id: cat?.catId,
                            categoryName: cat?.categoryName,
                        })),
                        allowSpecialItems: false,
                        allowExternalOrders: false,
                        }]
                        : []),
                recipeAuto: branchSettingsView?.autoRecipe,
                updateOrdAuth: branchSettingsView?.updateOrdAuth,
                updateOrdAuthEmployees: (branchSettingsView?.updateOrdAuthEmployees || []).map((emp) => ({
                    _id: emp?.employeeId || emp?._id,
                    staff_name: emp?.name || emp?.staff_name,
                })),
                cancelOrdAuth: branchSettingsView?.cancelOrdAuth,
                cancelOrdAuthEmployees: (branchSettingsView?.cancelOrdAuthEmployees || []).map((emp) => ({
                    _id: emp?.employeeId || emp?._id,
                    staff_name: emp?.name || emp?.staff_name,
                })),
                addDiscountAuth: branchSettingsView?.addDiscountAuth,
                addDiscountAuthEmployees: (branchSettingsView?.addDiscountAuthEmployees || []).map((emp) => ({
                    _id: emp?.employeeId || emp?._id,
                    staff_name: emp?.name || emp?.staff_name,
                })),
                enableMultipleOrder: branchSettingsView?.enableMultipleOrder,
                deliveryCharge: branchSettingsView?.deliveryCharge,
                deliveryAmt: Number(branchSettingsView?.deliveryAmt)?.toFixed(decimalPosition),
                deliveryChargeMode: branchSettingsView?.deliveryChargeMode || "flat",
                perKmCharge: branchSettingsView?.perKmCharge !== undefined && branchSettingsView?.perKmCharge !== null ? Number(branchSettingsView?.perKmCharge)?.toFixed(decimalPosition) : "",
                freeDeliveryAbove: branchSettingsView?.freeDeliveryAbove !== undefined && branchSettingsView?.freeDeliveryAbove !== null ? Number(branchSettingsView?.freeDeliveryAbove)?.toFixed(decimalPosition) : "",
                kmRangeRules: Array.isArray(branchSettingsView?.kmRangeRules) ? branchSettingsView?.kmRangeRules : [],
                deliveryChargeAggregators: restoredAggregators,
                packageCharge: branchSettingsView?.packagingCharge,
                openingBalFromInvenrory: branchSettingsView?.openingBalFromInvenrory,
                iaPhysicalClosingManual: branchSettingsView?.iaPhysicalClosingManual || false,
                packageAmt: Number(branchSettingsView?.pkgCharge)?.toFixed(decimalPosition),
                printCount: branchSettingsView?.printCount || 1,
                noDecreasePrice: branchSettingsView?.noDecreasePrice || false
            })
        }
    }, [branchSettingsView])
    return (
        <div className='new-global-white-bg-container'>
            <h4>POS Configurations</h4>
            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="enableKot"
                    value={formValues?.enableKot}
                    onChange={checkboxChange("enableKot")}
                    checked={formValues?.enableKot}
                />
                <label htmlFor="enableKot">KOT</label>
            </div>

            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="enablePosDevices"
                    value={formValues?.enablePosDevices}
                    onChange={checkboxChange("enablePosDevices")}
                    checked={formValues?.enablePosDevices}
                />
                <label htmlFor="enablePosDevices">Add POS devices</label>
            </div>
            {
                formValues?.enablePosDevices && (
                    <div className='pos-settings-dropdown-container auto-complete-new' style={{ flexDirection: "column", gap: 12 }}>
                        <p style={{ fontWeight: 600, margin: '0 0 4px 0' }}>POS device assignments</p>
                        {(formValues?.posDevices || []).map((device, index) => (
                            <div
                                key={device?._id || index}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10,
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 10,
                                    padding: 10,
                                    background: "#fff",
                                    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                                    maxWidth: 980
                                }}
                            >
                                <div style={{ display: "grid", gridTemplateColumns: "1fr auto auto", gap: 8, alignItems: "center" }}>
                                    <TextField
                                        label="Device name"
                                        size="small"
                                        value={device?.name || ""}
                                        onChange={(e) => {
                                            const name = e.target.value;
                                            setFormValues((prev) => {
                                                const next = [...(prev.posDevices || [])];
                                                next[index] = { ...next[index], name };
                                                return { ...prev, posDevices: next };
                                            });
                                        }}
                                        sx={{ width: "100%", '& .MuiInputBase-input': { padding: '6px 10px' } }}
                                    />
                                    <div style={{ display: "inline-flex", alignItems: "center", gap: 6, justifySelf: "end" }}>
                                        <span style={{ fontSize: 12.5, color: '#444' }}>Special items</span>
                                        <Switch
                                            size="small"
                                            checked={device?.allowSpecialItems || false}
                                            onChange={(event) =>
                                                setFormValues((prev) => {
                                                    const next = [...(prev.posDevices || [])];
                                                    next[index] = {
                                                        ...next[index],
                                                        allowSpecialItems: event.target.checked,
                                                    };
                                                    return { ...prev, posDevices: next };
                                                })
                                            }
                                        />
                                    </div>
                                    <div style={{ display: "inline-flex", alignItems: "center", gap: 6, justifySelf: "end" }}>
                                        <span style={{ fontSize: 12.5, color: '#444' }}>External orders</span>
                                        <Switch
                                            size="small"
                                            checked={device?.allowExternalOrders || false}
                                            onChange={(event) =>
                                                setFormValues((prev) => {
                                                    const next = [...(prev.posDevices || [])];
                                                    next[index] = {
                                                        ...next[index],
                                                        allowExternalOrders: event.target.checked,
                                                    };
                                                    return { ...prev, posDevices: next };
                                                })
                                            }
                                        />
                                    </div>
                                    <Button
                                        color='error'
                                        variant='outlined'
                                        size='small'
                                        onClick={() =>
                                            setFormValues((prev) => ({
                                                ...prev,
                                                posDevices: (prev.posDevices || []).filter((_, idx) => idx !== index)
                                            }))
                                        }
                                        sx={{ justifySelf: 'end', padding: '3px 10px', textTransform: 'none', borderColor: '#ffc6c6', color: '#d32f2f' }}
                                    >
                                        Remove
                                    </Button>
                                </div>

                                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(260px, 1fr))", gap: 12 }}>
                                    <div className="global-single-input" style={{ width: "100%" }}>
                                        <p style={{ marginBottom: 6 }}>Allow employees</p>
                                        <Autocomplete
                                            multiple
                                            disableCloseOnSelect
                                            options={employeeList || []}
                                            isOptionEqualToValue={(option, value) => option?._id === value?._id}
                                            getOptionLabel={(option) => option?.staff_name || ""}
                                            renderInput={(params) => (<TextField {...params} size='small' placeholder='Select employees' sx={{ '& .MuiInputBase-input': { padding: '6px 8px' } }} />)}
                                            value={device?.employees || []}
                                            onChange={(event, newValue) =>
                                                setFormValues((prev) => {
                                                    const next = [...(prev.posDevices || [])];
                                                    next[index] = { ...next[index], employees: newValue || [] };
                                                    return { ...prev, posDevices: next };
                                                })
                                            }
                                            sx={{ width: "100%", '& .MuiChip-root': { height: 22, fontSize: 12 }, '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px' } }}
                                        />
                                        <p style={{ fontSize: 11, color: '#7a7a7a', marginTop: 4 }}>Leave empty to allow all employees.</p>
                                    </div>

                                    <div className="global-single-input" style={{ width: "100%" }}>
                                        <p style={{ marginBottom: 6 }}>Allow categories</p>
                                        <Autocomplete
                                            multiple
                                            disableCloseOnSelect
                                            options={CategoryList || []}
                                            isOptionEqualToValue={(option, value) => option?._id === value?._id}
                                            getOptionLabel={(option) => option?.categoryName || ""}
                                            renderInput={(params) => (<TextField {...params} size='small' placeholder='Select categories' sx={{ '& .MuiInputBase-input': { padding: '6px 8px' } }} />)}
                                            value={device?.categories || []}
                                            onChange={(event, newValue) =>
                                                setFormValues((prev) => {
                                                    const next = [...(prev.posDevices || [])];
                                                    next[index] = { ...next[index], categories: newValue || [] };
                                                    return { ...prev, posDevices: next };
                                                })
                                            }
                                            sx={{ width: "100%", '& .MuiChip-root': { height: 22, fontSize: 12 }, '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px' } }}
                                        />
                                        <p style={{ fontSize: 11, color: '#7a7a7a', marginTop: 4 }}>Leave empty to allow all categories.</p>
                                    </div>
                                </div>
                            </div>
                        ))}

                        <Button
                            variant='contained'
                            onClick={() =>
                                setFormValues((prev) => ({
                                    ...prev,
                                    posDevices: [
                                        ...(prev.posDevices || []),
                                        {
                                            _id: `pos-device-${(prev.posDevices?.length || 0) + 1}-${Date.now()}`,
                                            name: `POS Device ${(prev.posDevices?.length || 0) + 1}`,
                                            employees: [],
                                            categories: [],
                                            allowExternalOrders: false,
                                        }
                                    ]
                                }))
                            }
                            sx={{ alignSelf: "flex-start" }}
                        >
                            Add POS device
                        </Button>
                    </div>
                )
            }

            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="recipeAuto"
                    value={formValues?.recipeAuto}
                    onChange={checkboxChange("recipeAuto")}
                    checked={formValues?.recipeAuto === true}
                />
                <label htmlFor="recipeAuto">Recipe auto preperation</label>
            </div>
            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="updateOrdAuth"
                    value={formValues?.updateOrdAuth}
                    onChange={checkboxChange("updateOrdAuth")}
                    checked={formValues?.updateOrdAuth}
                />
                <label htmlFor="updateOrdAuth">Order Edit Authentication</label>
            </div>
            {
                formValues?.updateOrdAuth && (
                    <div style={{ marginLeft: '30px', marginBottom: '12px', marginTop: '6px' }}>
                        <Autocomplete
                            multiple
                            disableCloseOnSelect
                            options={employeeList || []}
                            isOptionEqualToValue={(option, value) => option?._id === value?._id}
                            getOptionLabel={(option) => option?.staff_name || ""}
                            renderInput={(params) => (<TextField {...params} size='small' placeholder='Select employees' />)}
                            value={formValues?.updateOrdAuthEmployees || []}
                            onChange={(event, newValue) => setFormValues({ ...formValues, updateOrdAuthEmployees: newValue || [] })}
                            sx={{ width: "100%", maxWidth: 400 }}
                        />
                        <p style={{ fontSize: 11, color: '#888', marginTop: 4, fontStyle: 'italic' }}>Selected employees can authorize order edits with their password.</p>
                    </div>
                )
            }
            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="cancelOrdAuth"
                    value={formValues?.cancelOrdAuth}
                    onChange={checkboxChange("cancelOrdAuth")}
                    checked={formValues?.cancelOrdAuth}
                />
                <label htmlFor="cancelOrdAuth">Order Cancel Authentication</label>
            </div>
            {
                formValues?.cancelOrdAuth && (
                    <div style={{ marginLeft: '30px', marginBottom: '12px', marginTop: '6px' }}>
                        <Autocomplete
                            multiple
                            disableCloseOnSelect
                            options={employeeList || []}
                            isOptionEqualToValue={(option, value) => option?._id === value?._id}
                            getOptionLabel={(option) => option?.staff_name || ""}
                            renderInput={(params) => (<TextField {...params} size='small' placeholder='Select employees' />)}
                            value={formValues?.cancelOrdAuthEmployees || []}
                            onChange={(event, newValue) => setFormValues({ ...formValues, cancelOrdAuthEmployees: newValue || [] })}
                            sx={{ width: "100%", maxWidth: 400 }}
                        />
                        <p style={{ fontSize: 11, color: '#888', marginTop: 4, fontStyle: 'italic' }}>Selected employees can authorize order cancellations with their password.</p>
                    </div>
                )
            }
            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="addDiscountAuth"
                    value={formValues?.addDiscountAuth}
                    onChange={checkboxChange("addDiscountAuth")}
                    checked={formValues?.addDiscountAuth}
                />
                <label htmlFor="addDiscountAuth">Discount Authentication</label>
            </div>
            {
                formValues?.addDiscountAuth && (
                    <div style={{ marginLeft: '30px', marginBottom: '12px', marginTop: '6px' }}>
                        <Autocomplete
                            multiple
                            disableCloseOnSelect
                            options={employeeList || []}
                            isOptionEqualToValue={(option, value) => option?._id === value?._id}
                            getOptionLabel={(option) => option?.staff_name || ""}
                            renderInput={(params) => (<TextField {...params} size='small' placeholder='Select employees' />)}
                            value={formValues?.addDiscountAuthEmployees || []}
                            onChange={(event, newValue) => setFormValues({ ...formValues, addDiscountAuthEmployees: newValue || [] })}
                            sx={{ width: "100%", maxWidth: 400 }}
                        />
                        <p style={{ fontSize: 11, color: '#888', marginTop: 4, fontStyle: 'italic' }}>Selected employees can authorize discounts with their password.</p>
                    </div>
                )
            }
            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="enableMultipleOrder"
                    value={formValues?.enableMultipleOrder}
                    onChange={checkboxChange("enableMultipleOrder")}
                    checked={formValues?.enableMultipleOrder}
                />
                <label htmlFor="enableMultipleOrder">Multiple Order Selection In Single Table</label>
            </div>

            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="noDecreasePrice"
                    value={formValues?.noDecreasePrice}
                    onChange={checkboxChange("noDecreasePrice")}
                    checked={formValues?.noDecreasePrice}
                />
                <label htmlFor="noDecreasePrice">Selling price cannot decrease</label>
            </div>


            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="deliveryCharge"
                    value={formValues?.deliveryCharge}
                    onChange={checkboxChange("deliveryCharge")}
                    checked={formValues?.deliveryCharge === true}
                />
                <label htmlFor="deliveryCharge">Delivery Charge</label>
            </div>
            {
                formValues?.deliveryCharge &&
                <>
                    <div className='pos-settings-dropdown-container auto-complete-new'>
                        <p>Charge Mode</p>
                        <Autocomplete
                            options={[
                                { label: "Flat", value: "flat" },
                                { label: "Per Km", value: "per_km" },
                                { label: "Km Range", value: "km_range" }
                            ]}
                            isOptionEqualToValue={(option, value) => option?.value === value?.value}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => (<TextField {...params} />)}
                            value={[{ label: "Flat", value: "flat" }, { label: "Per Km", value: "per_km" }, { label: "Km Range", value: "km_range" }].find(opt => opt.value === formValues?.deliveryChargeMode) || { label: "Flat", value: "flat" }}
                            onChange={(e, newValue) => setFormValues({ ...formValues, deliveryChargeMode: newValue?.value || "flat" })}
                            style={{ width: "160px" }}
                        />
                    </div>
                    {formValues?.deliveryChargeMode === "flat" && (
                        <div className='pos-settings-dropdown-container auto-complete-new'>
                            <p>Delivery Amount</p>
                            <TextField
                                value={formValues?.deliveryAmt}
                                onChange={getFormInfo("deliveryAmt")}
                                fullWidth
                                sx={{ input: { padding: "4px" } }}
                                onFocus={(e) => e.target.select()}
                                style={{ width: "120px" }}
                                onBlur={roundValues}
                            />
                            <p className='doc-validation-alert'>{validationAlert?.deliveryAmt}</p>
                        </div>
                    )}
                    {formValues?.deliveryChargeMode === "per_km" && (
                        <div className='pos-settings-dropdown-container auto-complete-new'>
                            <p>Per Km Charge</p>
                            <TextField
                                value={formValues?.perKmCharge}
                                onChange={getFormInfo("perKmCharge")}
                                fullWidth
                                sx={{ input: { padding: "4px" } }}
                                onFocus={(e) => e.target.select()}
                                style={{ width: "120px" }}
                                onBlur={roundValues}
                            />
                        </div>
                    )}
                    {formValues?.deliveryChargeMode === "km_range" && (
                        <div className='pos-settings-dropdown-container auto-complete-new' style={{ flexDirection: "column", gap: 8 }}>
                            <p>Km Range Rules</p>
                            <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                                {formValues?.kmRangeRules?.map((r, i) => (
                                    <div key={i} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                                        <TextField placeholder="From" value={r?.fromKm || ""} onChange={(e) => {
                                            const arr = [...formValues.kmRangeRules];
                                            arr[i] = { ...arr[i], fromKm: Number(e.target.value) };
                                            setFormValues({ ...formValues, kmRangeRules: arr })
                                        }} sx={{ input: { padding: "4px", width: 70 } }} />
                                        <TextField placeholder="To" value={r?.toKm || ""} onChange={(e) => {
                                            const arr = [...formValues.kmRangeRules];
                                            arr[i] = { ...arr[i], toKm: Number(e.target.value) };
                                            setFormValues({ ...formValues, kmRangeRules: arr })
                                        }} sx={{ input: { padding: "4px", width: 70 } }} />
                                        <TextField placeholder="Charge" value={r?.charge ?? ""} onChange={(e) => {
                                            const arr = [...formValues.kmRangeRules];
                                            const val = e.target.value === "" ? "" : Number(e.target.value)?.toFixed(decimalPosition);
                                            arr[i] = { ...arr[i], charge: val };
                                            setFormValues({ ...formValues, kmRangeRules: arr })
                                        }} sx={{ input: { padding: "4px", width: 90 } }} />
                                        <div className='pos-settings-checkbox-container' style={{ margin: 0 }}>
                                            <input type="checkbox" id={`free-${i}`} checked={!!r?.isFree} onChange={(e) => {
                                                const arr = [...formValues.kmRangeRules];
                                                arr[i] = { ...arr[i], isFree: e.target.checked };
                                                setFormValues({ ...formValues, kmRangeRules: arr })
                                            }} />
                                            <label htmlFor={`free-${i}`}>Free</label>
                                        </div>
                                        <Button variant='outlined' color='error' onClick={() => {
                                            const arr = [...formValues.kmRangeRules];
                                            arr.splice(i, 1);
                                            setFormValues({ ...formValues, kmRangeRules: arr })
                                        }}>Remove</Button>
                                    </div>
                                ))}
                            </div>
                            <div style={{ marginTop: 8 }}>
                                <Button variant='contained' onClick={() => setFormValues({ ...formValues, kmRangeRules: [...formValues.kmRangeRules, { fromKm: 0, toKm: 0, charge: 0, isFree: false }] })}>Add Range</Button>
                            </div>
                        </div>
                    )}
                    <div className='pos-settings-dropdown-container auto-complete-new'>
                        <p>Free Delivery Above Amount</p>
                        <TextField
                            value={formValues?.freeDeliveryAbove}
                            onChange={getFormInfo("freeDeliveryAbove")}
                            fullWidth
                            sx={{ input: { padding: "4px" } }}
                            onFocus={(e) => e.target.select()}
                            style={{ width: "140px" }}
                            onBlur={roundValues}
                        />
                    </div>
                    <div className='pos-settings-dropdown-container auto-complete-new' style={{ flexDirection: "column", alignItems: "flex-start" }}>
                        <p>Apply Delivery Charge To Aggregators</p>
                        <Autocomplete
                            multiple
                            disableCloseOnSelect
                            options={aggregatorList || []}
                            isOptionEqualToValue={(option, value) => option?._id === value?._id}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select aggregators"
                                />
                            )}
                            value={formValues?.deliveryChargeAggregators}
                            onChange={getFormInfo("deliveryChargeAggregators")}
                            style={{ width: "100%", maxWidth: "400px" }}
                        />
                        <p style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                            Select aggregators that should use the delivery charge settings above (e.g., Self-delivery, Talabat, etc.)
                        </p>
                    </div>
                </>
            }
            <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="packageCharge"
                    value={formValues?.packageCharge}
                    onChange={checkboxChange("packageCharge")}
                    checked={formValues?.packageCharge}

                />
                <label htmlFor="packageCharge">Packaging Charge</label>
            </div>
            {
                formValues?.packageCharge &&
                <div className='pos-settings-dropdown-container auto-complete-new'>
                    <p>Package Amount </p>
                    <TextField
                        value={formValues?.packageAmt}
                        onChange={getFormInfo("packageAmt")}
                        fullWidth
                        sx={{ input: { padding: "4px" } }}
                        onFocus={(e) => e.target.select()}
                        style={{ width: "100px" }}
                        onBlur={roundValues}
                    />
                    <p className='doc-validation-alert'>{validationAlert?.packageAmt}</p>
                </div>
            }
            <div className="pos-settings-dropdown-container auto-complete-new">
                <p>Delivery Print Count</p>
                <Autocomplete
                    options={[1, 2, 3, 4, 5, 6, 7]}
                    getOptionLabel={(option) => String(option)}
                    isOptionEqualToValue={(option, value) => option === value}
                    renderInput={(params) => (<TextField {...params} />)}
                    value={formValues?.printCount}
                    onChange={getFormInfo("printCount")}
                    style={{ width: "100px" }}
                />
            </div>

             <div className='pos-settings-checkbox-container'>
                <input
                    type="checkbox"
                    id="iaPhysicalClosingManual"
                    value={formValues?.iaPhysicalClosingManual}
                    onChange={checkboxChange("iaPhysicalClosingManual")}
                    checked={formValues?.iaPhysicalClosingManual}
                />
                <label htmlFor="iaPhysicalClosingManual">IA Physical Closing Manual</label>
            </div>

            {/* WhatsApp moved to centralized Notification Settings */}
            {/* Go to: Staff → HRM → Notifications → Settings → WhatsApp tab */}
        </div>
    )
}

export default PosBranchConfigurations